// extracted by mini-css-extract-plugin
export default {"header":"Header_header__iuVDl","wrapper":"Header_wrapper__aHGcT","ava_block":"Header_ava_block__cO8Xg","nav_header":"Header_nav_header__h3ZS0"};